import { useState } from 'react';
import { StockSearch } from '../components/StockSearch';
import ChartOverview from '../components/financial/ChartOverview';

export function Home() {
  const [selectedSymbol, setSelectedSymbol] = useState<string | null>(null);

  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className="space-y-4 p-4 md:p-6">
        {/* <div className="bg-theme-secondary border border-theme-tertiary rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-2">Select a stock to analyze</h2>
          <StockSearch
            placeholder="Search for a stock symbol..."
            onSelect={(sym) => setSelectedSymbol(sym)}
            className="w-full"
          />
          {!selectedSymbol && (
            <p className="text-sm text-theme-muted mt-2">Enter a symbol to view multi-metric financial chart analysis.</p>
          )}
        </div> */}
        {/* {selectedSymbol && ( */}
        <div className="bg-theme-secondary border border-theme-tertiary rounded-lg p-2">
          <ChartOverview symbol={selectedSymbol} />
        </div>
        {/* )} */}
      </div>
    </div>
  );
}
